import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tarjetas-dashboard',
  templateUrl: './tarjetas-dashboard.component.html',
  styleUrl: './tarjetas-dashboard.component.scss',
  standalone: false
})

export class TarjetasDashboardComponent {
  @Input() participacionPct: number | null = null;
  @Input() objetivoPct: number | null = null;
  @Input() sumaTotal: number | null = null;

  // opcional: para mostrar fracción y no solo %
  @Input() participacionUsuarios: number | null = null;
  @Input() objetivoUsuarios: number | null = null;
  @Input() totalUsuarios: number | null = null;

  clampPct(value: number | null | undefined): number {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;
    return Math.min(100, Math.max(0, num));
  }

}
